import React, { useState } from "react";
import RewardType from "./RewardType";
import SurveyStatus from "./SurveyStatus";
import TransactionType from "./TransactionType";
import Reward from "./Reward";
import Transaction from "./Transaction";
import TransactionUtils from "./TransactionUtils";
import MailBox from "../SurveyHistory/MailBox";
import Stats from "./Stats/Stats";
import SurveyStats from "./SurveyStats/SurveyStats";


const TransactionHistory = () => {
  const [activeComponent, setActiveComponent] = useState("Stats")
  // Array with tab names and corresponding components
  const tabs = [
    { name: "Stats", component: <Stats /> },
    { name: "Survey Stats", component: <SurveyStats /> },
    { name: "POI", component: <Reward /> },
    { name: "Utility", component: <TransactionUtils /> },
    { name: "Invite history", component: <MailBox /> },
    // { name: "Reward Type", component:  <RewardType /> },
    // { name: "Survey Status", component: <SurveyStatus />},
    // { name: "Redeem Type", component: <TransactionType />},
    { name: "Redeem List", component: <Transaction /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name) => {
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col justify-center items-center w-full  sticky top-14 bg-[var(--bgColor)]" style={{ zIndex: 9 }}>
        <h1 className="text-xl m-4 font-semibold">Transaction History</h1>
        <div className="flex space-x-4 mb-6 max-w-100 flex-wrap gap-2">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`px-4 py-2 rounded-lg text-sm border-b-2 ${activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                }`}
              onClick={() => { changeActiveComponent(name) }}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default TransactionHistory;
